import { Link } from 'react-router-dom';

import { FiLogOut } from 'react-icons/fi';

import { useAuth } from '../../hooks/auth';
import { HeaderMenu } from '../HeaderMenu';

import logoWhite from '../../assets/img/logoWhite.png';

import { Container, MidContent, RightContent, Button } from './styles';

export const Header = () => {
  const { logOut, user } = useAuth();

  return (
    <Container>
      <HeaderMenu />
      <MidContent>
        <img src={logoWhite} alt="logo" />
      </MidContent>
      {user ? (
        <RightContent>
          <Button buttonColor="purple" onClick={logOut}>
            <p>Sair</p>
            <FiLogOut size={20} />
          </Button>
        </RightContent>
      ) : (
        <RightContent>
          <Link to="/cadastrar">
            <Button buttonColor="purple">
              <p>Cadastrar</p>
            </Button>
          </Link>
          <Link to="/">
            <Button buttonColor="green">
              <p>Fazer Login</p>
            </Button>
          </Link>
        </RightContent>
      )}
    </Container>
  );
};
